/** Shared customer ``cust_type`` display and automation eligibility (mirrors backend). */

export const CUST_TYPE_ON_HOLD = "On Hold";

export const CUSTOMER_STATUS_OPTIONS = [
  "Active",
  "Contract",
  CUST_TYPE_ON_HOLD,
  "Disabled",
  "Prospecting",
];

export const CUST_TYPE_STATUS_COLORS = {
  Active: "#4CAF50",
  Contract: "#2196F3",
  [CUST_TYPE_ON_HOLD]: "#FF9800",
  Disabled: "#9E9E9E",
  Prospecting: "#FFC107",
};

export const normalizeCustType = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const isOnHoldCustType = (custType) => normalizeCustType(custType) === "on hold";

export const isExcludedFromAutoActivationCustType = (custType) =>
  ["disabled", "prospecting", "on hold"].includes(normalizeCustType(custType));

export const getCustTypeStatusColor = (custType) =>
  CUST_TYPE_STATUS_COLORS[custType] || "#9E9E9E";

/** MUI ``color`` prop for typography chips. */
export const getCustTypeTypographyColor = (custType) => {
  if (isOnHoldCustType(custType)) return "warning";
  if (custType === "Active") return "success";
  if (custType === "Contract") return "info";
  if (custType === "Disabled") return "text";
  if (custType === "Prospecting") return "warning";
  return "text";
};

export const getCustomerHeaderTitle = ({
  custType,
  suspended,
  isClientPortal = false,
}) => {
  const onHold = isOnHoldCustType(custType);
  if (suspended || onHold) {
    if (isClientPortal) {
      if (onHold) return "My Account (ON HOLD)";
      return "My Account (SUSPENDED)";
    }
    if (onHold) return "Customer Information (ON HOLD)";
    return "Customer Information (SUSPENDED)";
  }
  return isClientPortal ? "My Account" : "Customer Information";
};

export const getCustomerHeaderGradient = ({ custType, suspended }) => {
  if (isOnHoldCustType(custType)) return "warning";
  if (suspended) return "error";
  return "info";
};
